export default "__VITE_ASSET__Bh57Uxff__"